import { z } from "zod";
import { FormBase, FormBaseProps, FormSubmitCallback, InputField, SelectField } from "ui";
import { useEffect, useState } from "react";
import { FieldProps } from "react-final-form";
import { usStates } from "../../constants/SelectFieldOpts/states";
const LOCATION_FORM_FIELDS: FieldProps<string, any>[] = [
    {
        name: "name",
        label: "Name",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 12
        }
    },
    {
        name: "streetLineOne",
        label: "Street Line One",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: { xs: 12 }
    },
    {
        name: "streetLineTwo",
        label: "Street Line Two",
        component: InputField,
        required: false,
        fullWidth: true,
        grid: { xs: 12 }
    },
    {
        name: "city",
        label: "City",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: { xs: 6 }
    },
    {
        name: "postalCode",
        label: "Postal Code",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: { xs: 6 }
    },
    {
        name: "state",
        label: "State",
        component: SelectField,
        options: usStates,
        required: true,
        fullWidth: true,
        grid: { xs: 6 }
    },
    {
        name: "country",
        label: "Country",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: { xs: 6 }
    }
]

const locationEditSchema = z.object({
    name: z.string().trim().max(255).min(1),
    streetLineOne: z.string().trim().max(255).min(1),
    streetLineTwo: z.string().trim().max(255).nullish(),
    city: z.string().trim().max(255).min(1),
    state: z.string().trim().max(255).min(1),
    postalCode: z.string().trim().max(10).min(1),
    country: z.string().trim().max(255).min(1)
});

export type LocationFormSchema = z.infer<typeof locationEditSchema>;

type FormState = {
    fields: FieldProps<string, any>[]
};

export type LocationFormProps = Pick<FormBaseProps<LocationFormSchema>, "initialValues" | "readonly">

export default function LocationForm({ initialValues, readonly }: LocationFormProps) {
    const [formState, setFormState] = useState<FormState>({
        fields: LOCATION_FORM_FIELDS
    })
    useEffect(() => {
        const fields = [
            ...LOCATION_FORM_FIELDS
        ]
        setFormState(prevState => ({
            ...prevState,
            fields
        }))
    }, [])

    const EditForm = FormBase<LocationFormSchema>({
        fields: formState.fields,
        initialValues: initialValues ?? {},
        validationSchema: locationEditSchema,
        buttonSubmitLabel: "Save",
        buttonCancelLabel: "Cancel",
        readonly,

    });
    return EditForm;
}